import type { ReactNode } from 'react'
import { useSectionObserver } from '@/teams/portfolio/hooks/use-section-observer/use-section-observer.ts'
import type { SectionId } from '@/teams/portfolio/types/section-id.ts'
import '@/teams/portfolio/components/section/section/section.scss'

interface SectionProps {
	ariaLabel?: string
	children: ReactNode
	className?: string
	id: SectionId
}

/**
 * Section component
 * Full-viewport section wrapper with anchor support for URL navigation
 */
export function Section({
	id,
	children,
	className,
	ariaLabel,
}: Readonly<SectionProps>) {
	const sectionRef = useSectionObserver(id)
	const sectionClasses = ['section', className].filter(Boolean).join(' ')

	return (
		<section
			aria-label={ariaLabel}
			className={sectionClasses}
			data-testid={`section_${id}`}
			id={id}
			ref={sectionRef}>
			{children}
		</section>
	)
}
